<template>
  <div class="error-page">
    <h2 class="h1">Error 404!</h2>
    <router-link to="/">Home</router-link>
  </div>
</template>

<script>
export default {
  name: "Error"
};
</script>

<style lang="scss">
.error-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: $background;
}
</style>
